import React, { useEffect, useMemo, useState } from "react";
import { Container, Col, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";

import { useTypedSelector } from "../../store/models/root.interface";
import { fetchDocuments } from "../../store/actions/subscriptions.actions";
import TitleMeta from "../../common/components/TitleMeta";
import Card from "../../components/DataPacks/DocumentCard";
import Loader from "../../common/components/Loader";
import Layout from "../../components/Layout/Layout";

const Subscription = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const subscriptions = useTypedSelector((state) => state.subscriptions.items);
  const documents = useTypedSelector((state) => state.subscriptions.documents);

  // Set number of times to inclement
  const [inclement] = useState(12);
  // Set default count
  const [counter, setCount] = useState(inclement);
  const count = counter;

  const [subscription] = useState(() =>
    subscriptions && typeof subscriptions !== "string"
      ? subscriptions.filter((x) => location.pathname.endsWith("/" + x.id))[0]
      : void 0
  );

  const items = useMemo(() => {
    if (subscription) {
      const list = documents[subscription.name];
      if (list && typeof list !== "string") {
        return list.items;
      }
    }
    return [];
  }, [documents]);
  // Set Pages items
  const pagedItems = items.slice(0, count).map((item: any) => item);

  const isLoading = useMemo(() => {
    return !!subscription && documents[subscription.name] === "loading";
  }, [documents]);

  const isError = useMemo(() => {
    return !!subscription && documents[subscription.name] === "error";
  }, [documents]);

  useEffect(() => {
    if (subscription) {
      dispatch(fetchDocuments(subscription.name));
    }
  }, []);

  return (
    <>
      <TitleMeta title={subscription?.name ?? "Data Pack"} />

      <Layout.FullPage>

        <Layout.Header>
          <Layout.Breadcrumb />
          <Layout.Title>{subscription?.name}</Layout.Title>
        </Layout.Header>

        <Layout.Body>
          <div className="position-relative">
            {isError ? (
              <p>Sorry, something went wrong.</p>
            ) : (
              <Row className="row-eq-height datapacks">
                {pagedItems.length || isLoading ? (
                  pagedItems.map((item, i) => (
                    <Col key={i} md={6} lg={6} xl={4} className="mb-3">
                      <Card {...item} />
                    </Col>
                  ))
                ) : (
                  <Col>No data packs are available</Col>
                )}
              </Row>
            )}
            <Loader show={isLoading} />
          </div>

          {!!items && items.length > counter && (
            <button
              className="full-width btn btn-info"
              onClick={() => setCount(count + inclement)}
            >
              Load more
            </button>
          )}
        </Layout.Body>

      </Layout.FullPage>
    </>
  );
};

export default Subscription;
